export default __webpack_public_path__ + "9a672e7b139550e9f9e4b926de282cb6.png";